import { parse } from "@ethersproject/transactions";
import AddIcon from "@mui/icons-material/Add";
import { Button, Popover, TextField } from "@mui/material"
import { ethers } from "ethers";
import KwilDB from "kwildb";
import { useRef, useState } from "react";
import ChainMap from "../nav-components/fundingPoolList-components/chainMap";
import BigNumber from "bignumber.js";

export default function AddFundsButton({ setStatus, setErrMsg, pool, multiplier, totalFunds, setTotalFunds, setTotalData, setAdding }) {
    const [anchorEl, setAnchorEl] = useState(null)
    const [amount, setAmount] = useState(0)
    const [balance, setBalance] = useState(0)

    const open = Boolean(anchorEl)

    const decimalCheck = useRef(
        pool.token === "USDC" ? 0.000001 : 0.000000000000000001
    )

    const shift = useRef(
        pool.token === "USDC" ? 6 : 18
    )
    
    function handleClick(event) {
        setAnchorEl(event.currentTarget)
    }

    function handleClose() {
        setAnchorEl(null)
    }

    function addFunds() {
        if (amount < decimalCheck.current) {
            setStatus("error")
            setErrMsg(`Enter an amount greater than ${decimalCheck.current} ${pool.token}`)
        } else {
            const chainID = ChainMap().get(pool.blockchain)
            setTimeout(async function () {
                if (window.ethereum.networkVersion !== chainID.int) {
                    try {
                        await window.ethereum.request({
                            method: "wallet_switchEthereumChain",
                            params: [{ chainId: chainID.hex }]
                        })
                    } catch (err) {
                        if (err.message === "User rejected the request.") {
                            window.alert("User rejected the request")
                        }
                        window.alert(
                            "You do not have the specified chain added to your wallet!"
                        )
                        return;
                    }
                }
                setAdding(true)
                await window.ethereum.send("eth_requestAccounts")
                const provider = new ethers.providers.Web3Provider(window.ethereum)
                const signer = provider.getSigner()
                const address = await signer.getAddress()
                const BN = new BigNumber(amount)

                const result = await KwilDB.pools.fundPool(
                    pool.pool_name,
                    address,
                    pool.blockchain,
                    pool.token,
                    BN.shiftedBy(shift.current)
                )
                setAdding(false)
                if (typeof result === "string") {
                    setStatus("fail")
                    setErrMsg(result)
                } else {
                    let newBal = parseInt(balance) + amount + multiplier.current
                    setBalance(newBal)
                    let newTotal = parseFloat(totalFunds) + parseFloat(amount)
                    setTotalFunds(newTotal)
                    setTotalData(Math.round((newTotal / (8.5 * 1.3)) * 1000000000))
                    setStatus("success")
                    handleClose()
                    window.location.reload(true)
                }
            }, 0)
        }
    }


    return(
        <>
            <Button
                onClick={handleClick}
                sx={{
                    display: "flex",
                    color: "#118EA0",
                    textTransform: "none",
                    justifyContent: "left",
                    fontWeight: "bold",
                    backgroundColor: "transparent",
                    paddingLeft: 0,
                    fontFamily: "Averta",
                    margin: "6px auto 6px 0px",
                    fontSize: "16px"
                }}
                endIcon={<AddIcon />}
            >
                Add Funds
            </Button>
            <Popover
                sx={{
                    borderRadius: "9px",
                    "& .MuiPopover-paper": {
                        backgroundColor: "#151515",
                      }
                }}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        backgroundColor: "#151515",
                        margin: "4px"
                    }}
                >
                    <TextField
                        sx={{
                            flex: 1,
                            backgroundColor: "#212121",
                            color: "#fff",
                            borderRadius: "9px",
                            // pl: "10px",
                            minHeight: "45px",
                            border: "none !important",
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none !important",
                                borderRadius: "9px",
                            },
                            "& .MuiInputBase-root": {
                                borderRadius: "9px",
                                color: "#fff",
                            }
                        }}
                        onChange={(e) => {setAmount(e.target.value)}}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                addFunds()
                            }
                        }}
                        placeholder="Amount"
                        value={amount === 0 ? "" : amount}
                        error={isNaN(amount)}
                        helperText={isNaN(amount) ? "Please enter a valid number" : ""}
                        inputProps={{
                            autoCorrect: "off"
                        }}
                    />
                    <Button
                        sx={{
                            color: "#fff",
                            textTransform: "none",
                            margin: "0px, 10px",
                            borderRadius: "9px"
                        }}
                        onClick={addFunds}
                    >
                        Submit
                    </Button>
                </div>
            </Popover>
        </>
    )
}